import TaxInformationWidget from './TaxInformationWidget';

export default TaxInformationWidget;
